var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPhoneIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#phone-icon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M14.2 16.261a12.13 12.13 0 0 1-6.453-6.468l3.4-3.406L4.887.122l-3.17 3.17A5.9 5.9 0 0 0 0 7.5C0 14.748 9.252 24 16.5 24a5.9 5.9 0 0 0 4.207-1.716l3.171-3.171-6.265-6.265zm5.092 4.609A3.9 3.9 0 0 1 16.5 22C10.267 22 2 13.733 2 7.5a3.9 3.9 0 0 1 1.13-2.793L4.887 2.95l3.437 3.437L5.39 9.322l.245.614a14.37 14.37 0 0 0 8.447 8.436l.606.231 2.926-2.927 3.437 3.437zM14 2V0a10.01 10.01 0 0 1 10 10h-2a8.01 8.01 0 0 0-8-8m0 4V4a6.006 6.006 0 0 1 6 6h-2a4 4 0 0 0-4-4"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "phone-icon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));
export default SvgPhoneIcon;